<template>
  <div class="privacy">
    <div class="px-4">
      <div class="text-sm font-weight-bold h5 mb-4 mt-0 text-center">
        <span class="font-weight-bold h5 my-4 px-3 mt-0"> سياسة الخصوصية </span>
      </div>

      <div class="d-flex justify-content-center px-4">
        <div>
          يصف إشعار الخصوصية هذا لشركة Systech Digital Co.ltd ("الشركة" أو "نحن"
          أو "لنا" أو "خاصتنا") كيف ولماذا قد نجمع و / أو نخزن و / أو نستخدم و /
          أو نشارك ("نعالج") المعلومات عند استخدام خدماتنا ("الخدمات") ، على
          سبيل المثال عندما:
          <ul>
            <li>
              قم بتنزيل واستخدام تطبيق الهاتف المحمول الخاص بنا (Imanyat) ، أو
              أي تطبيق آخر تابع لنا يرتبط بإشعار الخصوصية هذا
            </li>
            <li>
              الانخراط معنا بطرق أخرى ذات صلة ، بما في ذلك أي مبيعات أو تسويق أو
              أحداث أسئلة أو استفسارات؟ ستساعدك قراءة إشعار الخصوصية هذا على فهم
              حقوق وخيارات الخصوصية الخاصة بك. إذا كنت لا توافق على سياساتنا
              وممارساتنا ، فيرجى عدم استخدام خدماتنا. إذا كان لا يزال لديك أي
              أسئلة أو استفسارات ، فيرجى الاتصال بنا على info@systechsd.net.
            </li>
          </ul>
          <h6>ملخص النقاط الرئيسية</h6>
          <div>
            يوفر هذا الملخص النقاط الرئيسية من إشعار الخصوصية الخاص بنا ، ولكن
            يمكنك معرفة المزيد من التفاصيل حول أي من هذه الموضوعات بالنقر فوق
            الارتباط الذي يلي كل نقطة رئيسية أو باستخدام جدول المحتويات أدناه
            للعثور على القسم الذي تبحث عنه. يمكنك أيضًا النقر هنا للانتقال
            مباشرةً إلى جدول المحتويات الخاص بنا.
          </div>

          <div>
            ما هي المعلومات الشخصية التي نعالجها؟ عند زيارة خدماتنا أو استخدامها
            أو التنقل فيها ، قد نقوم بمعالجة المعلومات الشخصية بناءً على كيفية
            تفاعلك مع شركة Systech Digital Co.ltd والخدمات ، والاختيارات التي
            تقوم بها ، والمنتجات والميزات التي تستخدمها. انقر هنا لمعرفة المزيد.
          </div>
          <div>
            هل نعالج أي معلومات شخصية حساسة؟ نحن لا نعالج المعلومات الشخصية
            الحساسة.
          </div>
          <div>
            هل نتلقى أي معلومات من أطراف ثالثة؟ نحن لا نتلقى أي معلومات من أطراف
            ثالثة.
          </div>
          <div>
            كيف نعالج معلوماتك؟ نقوم بمعالجة معلوماتك لتوفير خدماتنا وتحسينها
            وإدارتها ، والتواصل معك ، من أجل الحماية ومنع الاحتيال ، والامتثال
            للقانون. قد نقوم أيضًا بمعالجة معلوماتك لأغراض أخرى بموافقتك. نعالج
            معلوماتك فقط عندما يكون لدينا سبب قانوني وجيه للقيام بذلك. انقر هنا
            لمعرفة المزيد.
          </div>
          <div>
            في أي مواقف ومع أي أطراف نشارك المعلومات الشخصية؟ قد نشارك المعلومات
            في مواقف محددة ومع أطراف ثالثة محددة. انقر هنا لمعرفة المزيد.
          </div>
          <div>
            كيف نحافظ على أمان معلوماتك؟ لدينا عمليات وإجراءات تنظيمية وفنية
            لحماية معلوماتك الشخصية. ومع ذلك ، لا يمكن ضمان أن يكون النقل
            الإلكتروني عبر الإنترنت أو تقنية تخزين المعلومات آمنًا بنسبة 100٪ ،
            لذلك لا يمكننا أن نعد أو نضمن أن المتسللين أو مجرمي الإنترنت أو
            غيرهم من الأطراف الثالثة غير المصرح لهم لن يكونوا قادرين على هزيمة
            أمننا وجمع الوصول والوصول بشكل غير صحيح أو سرقة أو تعديل معلوماتك.
            انقر هنا لمعرفة المزيد.
          </div>
          <div>
            ما هي حقوقك اعتمادًا على موقعك الجغرافي ، قد يعني قانون الخصوصية
            المعمول به أن لديك حقوقًا معينة فيما يتعلق بمعلوماتك الشخصية. انقر
            هنا لمعرفة المزيد.
          </div>
          <div>
            كيف تمارس حقوقك؟ أسهل طريقة لممارسة حقوقك هي ملء نموذج طلب موضوع
            البيانات المتاح هنا ، أو عن طريق الاتصال بنا. سننظر في أي طلب ونتصرف
            بناءً عليه وفقًا لقوانين حماية البيانات المعمول بها.
          </div>
          <div>
            هل تريد معرفة المزيد حول ما تفعله شركة Systech Digital Co.ltd بأي
            معلومات نجمعها؟ انقر هنا لمراجعة الإشعار بالكامل.
          </div>
          <br />
          <h6>جدول المحتويات</h6>
          <div class="">
            <ol>
              <li>ما هي المعلومات التي نجمعها؟</li>
              <li>كيف نعالج معلوماتك؟</li>
              <li>متى ومع من نشارك معلوماتك الشخصية؟</li>
              <li>هل نستخدم ملفات تعريف الارتباط وتقنيات التتبع الأخرى؟</li>
              <li>كيف نتعامل مع تسجيلات الدخول الاجتماعية الخاصة بك؟</li>
              <li>ما هي مدة احتفاظنا بمعلوماتك؟</li>
              <li>كيف نحافظ على أمان معلوماتك؟</li>
              <li>ما هي حقوق الخصوصية الخاصة بك؟</li>
              <li>ضوابط ميزات "عدم التعقب"</li>
              <li>هل يتمتع سكان كاليفورنيا بحقوق خصوصية محددة؟</li>
              <li>هل نجري تحديثات على هذا الإشعار؟</li>
              <li>كيف يمكنك الاتصال بنا بخصوص هذا الإشعار؟</li>
              <li>
                كيف يمكنك مراجعة أو تحديث أو حذف البيانات التي نجمعها منك؟
              </li>
            </ol>
          </div>
          <!-- point 1 -->
          <div>
            <div>1. ما هي المعلومات التي نجمعها؟</div>
            <div>المعلومات الشخصية التي تكشفها لنا</div>
            <div>باختصار: نحن نجمع المعلومات الشخصية التي تزودنا بها.</div>
            <div>
              نقوم بجمع المعلومات الشخصية التي تقدمها لنا طواعية عندما تقوم
              بالتسجيل في الخدمات ، أو تعبر عن اهتمامك بالحصول على معلومات عنا
              أو عن منتجاتنا وخدماتنا ، عندما تشارك في أنشطة على الخدمات ، أو
              بطريقة أخرى عندما تتصل بنا.
            </div>
            <div>
              المعلومات الشخصية التي قدمتها. تعتمد المعلومات الشخصية التي نجمعها
              على سياق تفاعلاتك معنا والخدمات ، والاختيارات التي تقوم بها ،
              والمنتجات والميزات التي تستخدمها. قد تتضمن المعلومات الشخصية التي
              نجمعها ما يلي:
            </div>
            <div>
              <ul>
                <li>الأسماء</li>
                <li>أرقام الهواتف</li>
                <li>عناوين البريد الإلكتروني</li>
                <li>أسماء المستخدمين</li>
                <li>كلمات السر</li>
              </ul>
              <p>معلومات حساسة. نحن لا نعالج المعلومات الحساسة.</p>
              <p>
                بيانات تسجيل الدخول إلى وسائل التواصل الاجتماعي. قد نوفر لك خيار
                التسجيل معنا باستخدام تفاصيل حساب الوسائط الاجتماعية الحالي
                الخاص بك ، مثل Facebook أو Twitter أو أي حساب آخر على وسائل
                التواصل الاجتماعي. إذا اخترت التسجيل بهذه الطريقة ، فسنجمع
                المعلومات الموضحة في القسم المسمى "كيف نتعامل مع اجتماعي الخاص
                بك.
              </p>
              <div>
                بيانات الطلب. إذا كنت تستخدم تطبيقنا (تطبيقاتنا) ، فقد نقوم
                أيضًا بجمع المعلومات التالية إذا اخترت تزويدنا بالوصول أو الإذن:
              </div>
              <div>
                <ul>
                  <li>
                    الوصول إلى الجهاز المحمول. قد نطلب الوصول أو الإذن إلى بعض
                    الميزات من جهازك المحمول ، بما في ذلك رسائل SMS الخاصة
                    بجهازك المحمول ، والتخزين ، والتقويم ، وغيرها من الميزات.
                    إذا كنت ترغب في تغيير وصولنا أو أذوناتنا ، فيمكنك القيام
                    بذلك في إعدادات جهازك.
                  </li>
                  <li>
                    بيانات الجهاز المحمول. نقوم تلقائيًا بجمع معلومات الجهاز
                    (مثل معرف جهازك المحمول والطراز والشركة المصنعة) ونظام
                    التشغيل ومعلومات الإصدار ومعلومات تكوين النظام وأرقام تعريف
                    الجهاز والتطبيق ونوع المتصفح والإصدار ومزود خدمة الإنترنت
                    لطراز الجهاز و / أو شركة الجوال ، وعنوان بروتوكول الإنترنت
                    (IP) (أو الخادم الوكيل). إذا كنت تستخدم تطبيقنا (تطبيقاتنا)
                    ، فقد نقوم أيضًا بجمع معلومات حول شبكة الهاتف المرتبطة
                    بجهازك المحمول ، ونظام تشغيل جهازك المحمول أو النظام الأساسي
                    له ، ونوع الجهاز المحمول الذي تستخدمه ، ومعرف الجهاز الفريد
                    الخاص بجهازك المحمول ، والمعلومات حول ميزات تطبيقنا
                    (تطبيقاتنا) التي قمت بالوصول إليها.
                  </li>
                  <li>
                    دفع الإخطارات. قد نطلب إرسال إشعارات فورية إليك بخصوص حسابك
                    أو بعض ميزات التطبيق (التطبيقات). إذا كنت ترغب في إلغاء
                    الاشتراك من تلقي هذه الأنواع من الاتصالات ، فيمكنك إيقاف
                    تشغيلها في إعدادات جهازك. هذه المعلومات ضرورية في المقام
                    الأول للحفاظ على أمان وتشغيل تطبيقنا (تطبيقاتنا) ، لاستكشاف
                    الأخطاء وإصلاحها ، ولأغراض التحليلات الداخلية وإعداد
                    التقارير الخاصة بنا. يجب أن تكون جميع المعلومات الشخصية التي
                    تقدمها لنا صحيحة وكاملة ودقيقة ، ويجب عليك إخطارنا بأي
                    تغييرات تطرأ على هذه المعلومات الشخصية. يتم جمع المعلومات
                    تلقائيًا باختصار: يتم جمع بعض المعلومات - مثل عنوان بروتوكول
                    الإنترنت (IP) و / أو خصائص المتصفح والجهاز - تلقائيًا عندما
                    تزور خدماتنا. نقوم تلقائيًا بجمع معلومات معينة عند زيارة
                    الخدمات أو استخدامها أو التنقل فيها. لا تكشف هذه المعلومات
                    عن هويتك المحددة (مثل اسمك أو معلومات الاتصال) ولكنها قد
                    تتضمن معلومات الجهاز والاستخدام ، مثل عنوان IP الخاص بك
                    وخصائص المتصفح والجهاز ونظام التشغيل وتفضيلات اللغة وعناوين
                    URL المرجعية واسم الجهاز والبلد والموقع ومعلومات حول كيفية
                    ووقت استخدامك لخدماتنا والمعلومات الفنية الأخرى. هذه
                    المعلومات ضرورية في المقام الأول للحفاظ على أمان وتشغيل
                    خدماتنا ، ولأغراض التحليلات الداخلية وإعداد التقارير.
                  </li>
                </ul>
                <div>
                  مثل العديد من الشركات ، نقوم أيضًا بجمع المعلومات من خلال
                  ملفات تعريف الارتباط والتقنيات المماثلة.
                </div>
                <strong>تتضمن المعلومات التي نجمعها ما يلي:</strong>
                <ul>
                  <li>
                    بيانات السجل والاستخدام. بيانات السجل والاستخدام هي معلومات
                    متعلقة بالخدمة والتشخيص والاستخدام والأداء تجمعها خوادمنا
                    تلقائيًا عند الوصول إلى خدماتنا أو استخدامها والتي نسجلها في
                    ملفات السجل. بناءً على كيفية تفاعلك معنا ، قد تتضمن بيانات
                    السجل هذه عنوان IP الخاص بك ومعلومات الجهاز ونوع المتصفح
                    والإعدادات والمعلومات حول نشاطك في الخدمات (مثل طوابع
                    التاريخ / الوقت المرتبطة باستخدامك والصفحات والملفات التي تم
                    عرضها وعمليات البحث والإجراءات الأخرى التي تتخذها مثل
                    الميزات التي تستخدمها) ومعلومات أحداث الجهاز (مثل نشاط
                    النظام وتقارير الأخطاء (تسمى أحيانًا "تفريغ الأعطال")
                    وإعدادات الأجهزة).
                  </li>
                  <li>
                    بيانات الجهاز. نقوم بجمع بيانات الجهاز مثل معلومات حول جهاز
                    الكمبيوتر أو الهاتف أو الجهاز اللوحي أو أي جهاز آخر تستخدمه
                    للوصول إلى الخدمات. اعتمادًا على الجهاز المستخدم ، قد تتضمن
                    بيانات هذا الجهاز معلومات مثل عنوان IP الخاص بك (أو الخادم
                    الوكيل) ، وأرقام تعريف الجهاز والتطبيق ، والموقع ، ونوع
                    المتصفح ، وطراز الجهاز ، ومزود خدمة الإنترنت و / أو شركة
                    الجوال ، ونظام التشغيل ، و معلومات تكوين النظام.
                  </li>
                  <li>
                    بيانات الموقع. نقوم بجمع بيانات الموقع مثل معلومات حول موقع
                    جهازك ، والتي يمكن أن تكون دقيقة أو غير دقيقة. يعتمد مقدار
                    المعلومات التي نجمعها على نوع وإعدادات الجهاز الذي تستخدمه
                    للوصول إلى الخدمات. على سبيل المثال ، قد نستخدم GPS وتقنيات
                    أخرى لجمع بيانات تحديد الموقع الجغرافي التي تخبرنا عن موقعك
                    الحالي (بناءً على عنوان IP الخاص بك). يمكنك إلغاء الاشتراك
                    في السماح لنا بجمع هذه المعلومات إما عن طريق رفض الوصول إلى
                    المعلومات أو عن طريق تعطيل إعداد الموقع الخاص بك على جهازك.
                    ومع ذلك ، إذا اخترت الانسحاب ، فقد لا تتمكن من استخدام جوانب
                    معينة من الخدمات.
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <!-- one -->

          <!-- point two -->
          <div class="point-2">
            <h6>2. كيف نعالج معلوماتك؟</h6>
            <div>
              باختصار: نقوم بمعالجة معلوماتك لتوفير خدماتنا وتحسينها وإدارتها
              والتواصل معك من أجل الحماية ومنع الاحتيال والامتثال للقانون. قد
              نقوم أيضًا بمعالجة معلوماتك لأغراض أخرى بموافقتك.
            </div>
            <strong
              >نعالج معلوماتك الشخصية لعدة أسباب ، اعتمادًا على كيفية تفاعلك مع
              خدماتنا ، بما في ذلك:</strong
            >
            <ul>
              <li>
                لتسهيل إنشاء الحساب والمصادقة وإدارة حسابات المستخدمين. قد نعالج
                معلوماتك حتى تتمكن من إنشاء حسابك وتسجيل الدخول إليه ، وكذلك
                الحفاظ على حسابك في حالة جيدة.
              </li>
              <li>
                تقديم وتسهيل تقديم الخدمات للمستخدم. قد نقوم بمعالجة معلوماتك
                لتزويدك بالخدمة المطلوبة.
              </li>
              <li>
                للرد على استفسارات المستخدم / تقديم الدعم للمستخدمين. قد نعالج
                معلوماتك للرد على استفساراتك وحل أي مشاكل محتملة قد تواجهك مع
                الخدمة المطلوبة.
              </li>
              <li>
                لطلب التغذية الراجعة. قد نعالج معلوماتك عند الضرورة لطلب
                التعليقات وللاتصال بك بشأن استخدامك لخدماتنا.
              </li>
              <li>
                إدارة الجوائز والمسابقات. قد نعالج معلوماتك لإدارة سحوبات
                الجوائز والمسابقات.
              </li>
              <li>
                لتقييم وتحسين خدماتنا ومنتجاتنا وتسويقنا وتجربتك. قد نعالج
                معلوماتك عندما نعتقد أنه من الضروري تحديد اتجاهات الاستخدام ،
                وتحديد فعالية حملاتنا الترويجية ، وتقييم وتحسين خدماتنا
                ومنتجاتنا وتسويقنا وتجربتك.
              </li>
              <li>
                للامتثال لالتزاماتنا القانونية. قد نعالج معلوماتك للامتثال
                لالتزاماتنا القانونية ، والاستجابة للطلبات القانونية ، وممارسة
                حقوقنا القانونية أو تأسيسها أو الدفاع عنها.
              </li>
            </ul>
          </div>
          <!-- end of point two -->

          <!-- point three -->
          <strong>3. متى ومع من نشارك معلوماتك الشخصية؟</strong>
          <p>
            باختصار: قد نشارك المعلومات في مواقف محددة موضحة في هذا القسم و / أو
            مع الأطراف الثالثة التالية.
          </p>
          <div>
            الباعة والمستشارون ومقدمو الخدمات الآخرون. يجوز لنا مشاركة بياناتك
            مع البائعين الخارجيين أو مزودي الخدمة أو المقاولين أو الوكلاء
            ("الأطراف الثالثة") الذين يؤدون خدمات لنا أو بالنيابة عنا ويطلبون
            الوصول إلى هذه المعلومات للقيام بهذا العمل. لدينا عقود سارية مع
            أطراف أخرى ، وهي مصممة للمساعدة في حماية معلوماتك الشخصية. هذا يعني
            أنه لا يمكنهم فعل أي شيء بمعلوماتك الشخصية ما لم نطلب منهم القيام
            بذلك. كما أنهم لن يشاركوا معلوماتك الشخصية مع أي منظمة غيرنا.
            يلتزمون أيضًا بحماية البيانات التي يحتفظون بها نيابة عنا والاحتفاظ
            بها للفترة التي نصدر تعليمات بها. الأطراف الثالثة التي قد نشارك
            المعلومات الشخصية معها هي كما يلي:
          </div>
          <ul>
            <li>
              الإعلان والتسويق المباشر وتوليد العملاء المحتملين جوجل ادسنس
            </li>
            <li>
              السماح للمستخدمين بالاتصال بحسابات الطرف الثالث الخاصة بهم حساب
              الفيسبوك
            </li>
            <li>خدمات الحوسبة السحابية خدمات أمازون ويب (AWS)</li>
            <li>التواصل والدردشة مع المستخدمين عامل الرسائل القصيرة</li>
            <li>تحسين المحتوى Google Site Search</li>
            <li>النسخ الاحتياطي للبيانات والأمن نهر الأمازون الجليدي</li>
            <li>تحسين الوظائف والبنية التحتية خدمات أمازون ويب</li>
            <li>الفاتورة والفواتير محفظة قوقل</li>
            <li>
              منصات إعادة الاستهداف تجديد النشاط التسويقي في Google Analytics
            </li>
            <li>
              مشاركة وسائل التواصل الاجتماعي والإعلان الإضافات الاجتماعية على
              Facebook
            </li>
            <li>تسجيل حساب المستخدم والمصادقة عليه OTP</li>
            <li>تعليقات المستخدم والمنتديات Google Tag Manager</li>
            <li>
              تحليلات الويب والجوال Google Analytics for Firebase و Google Tag
              Manager و Google Analytics
            </li>
            <li>مراقبة أداء الموقع تقارير الأعطال في Firebase</li>
            <li>اختبار الموقع محسّن مواقع الويب من Google</li>
          </ul>
          <strong
            >قد نحتاج أيضًا إلى مشاركة معلوماتك الشخصية في المواقف
            التالية:</strong
          >
          <ul>
            <li>
              تحويلات الأعمال. يجوز لنا مشاركة معلوماتك أو نقلها فيما يتعلق أو
              أثناء المفاوضات بشأن أي اندماج أو بيع أصول الشركة أو تمويل أو
              الاستحواذ على كل أو جزء من أعمالنا إلى شركة أخرى.
            </li>
            <li>
              عرض الحائط. قد يعرض تطبيقنا (تطبيقاتنا) "جدار عرض" مستضاف من طرف
              ثالث. يسمح جدار العرض هذا للمعلنين الخارجيين بتقديم عملة افتراضية
              أو هدايا أو عناصر أخرى للمستخدمين مقابل قبول عرض إعلاني واستكماله.
              قد يظهر جدار العرض هذا في تطبيقنا (تطبيقاتنا) ويتم عرضه لك بناءً
              على بيانات معينة ، مثل منطقتك الجغرافية أو معلوماتك الديموغرافية.
              عند النقر فوق أحد جدران العرض ، سيتم نقلك إلى موقع ويب خارجي تابع
              لأشخاص آخرين وستغادر تطبيقنا (تطبيقاتنا). ستتم مشاركة معرّف فريد ،
              مثل معرف المستخدم الخاص بك ، مع مزود جدار العرض من أجل منع
              الاحتيال وإئتمان حسابك بشكل صحيح بالمكافأة ذات الصلة.
            </li>
          </ul>
          <!-- point three -->
          <!-- point four -->
          <div>
            <strong
              >4. هل نستخدم ملفات تعريف الارتباط وتقنيات التتبع الأخرى؟</strong
            >
            <p>
              باختصار: قد نستخدم ملفات تعريف الارتباط وتقنيات التتبع الأخرى لجمع
              معلوماتك وتخزينها.
            </p>
            <div>
              قد نستخدم ملفات تعريف الارتباط وتقنيات التتبع المماثلة (مثل إشارات
              الويب ووحدات البكسل) للوصول إلى المعلومات أو تخزينها. معلومات
              محددة حول كيفية استخدامنا لهذه التقنيات وكيف يمكنك رفض بعض ملفات
              تعريف الارتباط مذكورة في إشعار ملفات تعريف الارتباط الخاص بنا.
            </div>
            <!-- point five -->
            <div>
              <strong
                >5. كيف نتعامل مع تسجيلات الدخول الاجتماعية الخاصة بك؟</strong
              >
              <p>
                باختصار: إذا اخترت التسجيل أو تسجيل الدخول إلى خدماتنا باستخدام
                حساب وسائل التواصل الاجتماعي ، فقد نتمكن من الوصول إلى معلومات
                معينة عنك.
              </p>
              <div>
                توفر لك خدماتنا القدرة على التسجيل وتسجيل الدخول باستخدام تفاصيل
                حساب وسائل التواصل الاجتماعي الخاصة بطرف ثالث (مثل تسجيلات
                الدخول على Facebook أو Twitter). عندما تختار القيام بذلك ، سوف
                نتلقى معلومات ملف تعريف معينة عنك من مزود الوسائط الاجتماعية
                الخاص بك. قد تختلف معلومات الملف الشخصي التي نتلقاها اعتمادًا
                على مزود وسائل التواصل الاجتماعي المعني ، ولكنها غالبًا ما تتضمن
                اسمك وعنوان بريدك الإلكتروني وقائمة الأصدقاء وصورة ملفك الشخصي ،
                بالإضافة إلى المعلومات الأخرى التي تختار نشرها على منصة التواصل
                الاجتماعي هذه.
              </div>
              <div>
                سنستخدم المعلومات التي نتلقاها فقط للأغراض الموضحة في إشعار
                الخصوصية هذا أو التي تم توضيحها لك بطريقة أخرى في الخدمات ذات
                الصلة. يرجى ملاحظة أننا لا نتحكم ، ولسنا مسؤولين عن ،
                الاستخدامات الأخرى لمعلوماتك الشخصية بواسطة موفر الوسائط
                الاجتماعية التابع لجهة خارجية. نوصي بمراجعة إشعار الخصوصية الخاص
                بهم لفهم كيفية جمعهم لمعلوماتك الشخصية واستخدامها ومشاركتها ،
                وكيف يمكنك تعيين تفضيلات الخصوصية الخاصة بك على مواقعهم
                وتطبيقاتهم.
              </div>
            </div>

            <!-- end point five -->

            <!-- point 6 -->

            <div>
              <strong>6. ما هي مدة احتفاظنا بمعلوماتك؟</strong>
              <p>
                باختصار: نحتفظ بمعلوماتك طالما كان ذلك ضروريًا لتحقيق الأغراض
                الموضحة في إشعار الخصوصية هذا ما لم يقتض القانون خلاف ذلك.
              </p>
              <div>
                سنحتفظ فقط بمعلوماتك الشخصية طالما كانت ضرورية للأغراض المنصوص
                عليها في إشعار الخصوصية هذا ، ما لم يكن هناك حاجة إلى فترة
                احتفاظ أطول أو مسموح بها بموجب القانون (مثل الضرائب أو المحاسبة
                أو المتطلبات القانونية الأخرى). لن يتطلب منا أي غرض في هذا
                الإشعار الاحتفاظ بمعلوماتك الشخصية لفترة أطول من الفترة الزمنية
                التي يكون لدى المستخدمين فيها حساب معنا.
              </div>
              <div>
                عندما لا يكون لدينا عمل شرعي مستمر لمعالجة معلوماتك الشخصية ،
                فسنقوم إما بحذف هذه المعلومات أو إخفاء هويتها ، أو إذا لم يكن
                ذلك ممكنًا (على سبيل المثال ، لأن معلوماتك الشخصية قد تم تخزينها
                في أرشيفات النسخ الاحتياطي) ، فسنقوم بذلك بأمان قم بتخزين
                معلوماتك الشخصية وعزلها عن أي معالجة أخرى حتى يصبح الحذف ممكنًا.
              </div>
            </div>

            <!-- point seven -->
            <div class="seven">
              <strong>7. كيف نحافظ على أمان معلوماتك؟</strong>
              <p>
                باختصار: نحن نهدف إلى حماية معلوماتك الشخصية من خلال نظام من
                التدابير الأمنية التنظيمية والفنية.
              </p>
              <div>
                لقد قمنا بتنفيذ تدابير أمنية تقنية وتنظيمية مناسبة ومعقولة مصممة
                لحماية أمن أي معلومات شخصية نقوم بمعالجتها. ومع ذلك ، على الرغم
                من الضمانات والجهود التي نبذلها لتأمين معلوماتك ، لا يمكن ضمان
                أن يكون النقل الإلكتروني عبر الإنترنت أو تقنية تخزين المعلومات
                آمنًا بنسبة 100٪ ، لذلك لا يمكننا أن نعد أو نضمن أن المتسللين أو
                مجرمي الإنترنت أو غيرهم من الأطراف الثالثة غير المصرح لهم لن
                يكونوا قادرًا على هزيمة أمننا وجمع معلوماتك أو الوصول إليها أو
                سرقتها أو تعديلها بشكل غير صحيح. على الرغم من أننا سنبذل قصارى
                جهدنا لحماية معلوماتك الشخصية ، فإن نقل المعلومات الشخصية من
                وإلى خدماتنا يكون على مسؤوليتك الخاصة. يجب عليك الوصول إلى
                الخدمات فقط في بيئة آمنة.
              </div>
            </div>
            <!-- eight -->
            <div class="eight">
              <strong>8. ما هي حقوق الخصوصية الخاصة بك؟</strong>
              <p>باختصار: يمكنك مراجعة حسابك أو تغييره أو إنهائه في أي وقت.</p>
              <div>
                إذا كنت مقيمًا في المنطقة الاقتصادية الأوروبية أو المملكة
                المتحدة وتعتقد أننا نعالج معلوماتك الشخصية بشكل غير قانوني ،
                فيحق لك أيضًا تقديم شكوى إلى السلطة الإشرافية المحلية لحماية
                البيانات. يمكنك العثور على تفاصيل الاتصال الخاصة بهم :
                <a
                  href="https://ec.europa.eu/justice/data-protection/bodies/authorities/index_en.htm."
                  >هنا</a
                >
              </div>
              <div>
                إذا كنت مقيمًا في سويسرا ، فإن تفاصيل الاتصال بهيئات حماية
                البيانات متاحة :
                <a href="  https://www.edoeb.admin.ch/edoeb/en/home.html."
                  >هنا</a
                >
              </div>
              <div>
                سحب موافقتك: إذا كنا نعتمد على موافقتك لمعالجة معلوماتك الشخصية
                ، والتي قد تكون موافقة صريحة و / أو ضمنية وفقًا للقانون المعمول
                به ، فيحق لك سحب موافقتك في أي وقت. يمكنك سحب موافقتك في أي وقت
                عن طريق الاتصال بنا باستخدام تفاصيل الاتصال الواردة في قسم "كيف
                يمكنك الاتصال بنا بخصوص هذا الإشعار؟" أقل.
              </div>
              <p>
                ومع ذلك ، يرجى ملاحظة أن هذا لن يؤثر على قانونية المعالجة قبل
                سحبها ولن يؤثر ، عندما يسمح القانون المعمول به ، على معالجة
                معلوماتك الشخصية التي تتم بالاعتماد على أسس معالجة قانونية بخلاف
                الموافقة.
              </p>
              <p>معلومات الحساب</p>
              <strong
                >إذا كنت ترغب في أي وقت في مراجعة أو تغيير المعلومات الموجودة في
                حسابك أو إنهاء حسابك ، فيمكنك:</strong
              >
              <ul>
                <li>
                  تسجيل الدخول إلى إعدادات حسابك وتحديث حساب المستخدم الخاص بك
                </li>
                <li>اتصل بنا باستخدام معلومات الاتصال المقدمة</li>
              </ul>
              <p>
                بناءً على طلبك لإنهاء حسابك ، سنقوم بإلغاء تنشيط أو حذف حسابك
                ومعلوماتك من قواعد البيانات النشطة لدينا. ومع ذلك ، قد نحتفظ
                ببعض المعلومات في ملفاتنا لمنع الاحتيال واستكشاف المشكلات
                وإصلاحها والمساعدة في أي تحقيقات وفرض شروطنا القانونية و / أو
                الامتثال للمتطلبات القانونية المعمول بها.
              </p>
              <p>
                ملفات تعريف الارتباط والتقنيات المشابهة: يتم تعيين معظم متصفحات
                الويب على قبول ملفات تعريف الارتباط افتراضيًا. إذا كنت تفضل ذلك
                ، يمكنك عادةً اختيار ضبط متصفحك لإزالة ملفات تعريف الارتباط ورفض
                ملفات تعريف الارتباط. إذا اخترت إزالة ملفات تعريف الارتباط أو
                رفض ملفات تعريف الارتباط ، فقد يؤثر ذلك على ميزات أو خدمات معينة
                لخدماتنا. لإلغاء الاشتراك في الإعلانات القائمة على الاهتمامات من
                قبل المعلنين على خدماتنا ، قم بزيارة
                <a href="http://www.aboutads.info/choices/."> قم بزيارة</a>
              </p>
              <p>
                إذا كانت لديك أسئلة أو تعليقات حول حقوق الخصوصية الخاصة بك ،
                فيمكنك مراسلتنا عبر البريد الإلكتروني على info@systechsd.net.
              </p>
            </div>
            <!-- nien -->
            <div class="nien">
              <strong>9. ضوابط ميزات "عدم التعقب"</strong>
              <div>
                تتضمن معظم متصفحات الويب وبعض أنظمة تشغيل الأجهزة المحمولة
                وتطبيقات الهاتف المحمول ميزة Do-Not-Track ("DNT") أو الإعداد
                الذي يمكنك تنشيطه للإشارة إلى تفضيل الخصوصية لديك بحيث لا تتم
                مراقبة وجمع بيانات حول أنشطة التصفح عبر الإنترنت الخاصة بك. في
                هذه المرحلة ، لم يتم الانتهاء من أي معيار تقني موحد للتعرف على
                إشارات DNT وتنفيذها. على هذا النحو ، نحن لا نستجيب حاليًا
                لإشارات مستعرض DNT أو أي آلية أخرى تقوم تلقائيًا بإبلاغ اختيارك
                بعدم التعقب عبر الإنترنت. إذا تم اعتماد معيار للتتبع عبر
                الإنترنت يجب علينا اتباعه في المستقبل ، فسنبلغك بهذه الممارسة في
                نسخة منقحة من إشعار الخصوصية هذا.
              </div>
              <h6>إشعار خصوصية CCPA</h6>
              <h6>يعرّف قانون لوائح ولاية كاليفورنيا "المقيم" على أنه:</h6>
              <p>
                (1) كل فرد موجود في ولاية كاليفورنيا لغير الأغراض المؤقتة أو
                المؤقتة و
              </p>
              <p>
                (2) كل فرد مقيم في ولاية كاليفورنيا وموجود خارج ولاية كاليفورنيا
                لغرض مؤقت أو مؤقت
              </p>
              <p>يتم تعريف جميع الأفراد الآخرين على أنهم "غير مقيمين".</p>
              <p>
                إذا كان تعريف "المقيم" ينطبق عليك ، فيجب علينا الالتزام ببعض
                الحقوق والالتزامات المتعلقة بمعلوماتك الشخصية.
              </p>
              <h6>ما هي فئات المعلومات الشخصية التي نجمعها؟</h6>
              <p>
                تم تجميع أمثلة الفئات معرفات تفاصيل الاتصال ، مثل الاسم الحقيقي
                والاسم المستعار والعنوان البريدي ورقم الهاتف أو الهاتف المحمول
                والمعرف الشخصي الفريد والمعرف عبر الإنترنت وعنوان بروتوكول
                الإنترنت وعنوان البريد الإلكتروني واسم الحساب. نعم
              </p>
              <p>
                ج- خصائص التصنيف المحمية بموجب قانون كاليفورنيا أو القانون
                الفيدرالي الجنس وتاريخ الميلاد. لا
              </p>
              <p>
                د. المعلومات التجارية معلومات المعاملة وسجل الشراء والتفاصيل
                المالية ومعلومات الدفع. لا
              </p>
              <p>ه. المعلومات البيومترية بصمات الأصابع وبصمات الصوت. لا</p>
              <p>
                و. الإنترنت أو أي نشاط شبكة مشابه آخر ، محفوظات الاستعراض ،
                ومحفوظات البحث ، والسلوك عبر الإنترنت ، وبيانات الاهتمام ،
                والتفاعلات مع مواقع الويب الخاصة بنا ومواقع الويب والتطبيقات
                والأنظمة والإعلانات الأخرى الخاصة بنا. نعم
              </p>
              <p>ز. موقع الجهاز بيانات تحديد الموقع الجغرافي. نعم</p>
              <p>
                ح. المعلومات الصوتية أو الإلكترونية أو المرئية أو الحرارية أو
                الشمية أو ما شابه ذلك الصور والتسجيلات الصوتية أو الفيديو أو
                المكالمات التي تم إنشاؤها فيما يتعلق بأنشطة أعمالنا .لا
              </p>
              <p>
                ط. المعلومات المهنية أو المتعلقة بالتوظيف تفاصيل الاتصال بالعمل
                من أجل تزويدك بخدماتنا على مستوى العمل أو المسمى الوظيفي وتاريخ
                العمل والمؤهلات المهنية إذا تقدمت بطلب للحصول على وظيفة معنا. لا
              </p>
              <p>ك. معلومات التعليم سجلات الطلاب ومعلومات الدليل. لا</p>
              <p>
                ل. الاستنتاجات المستمدة من المعلومات الشخصية الأخرى الاستدلالات
                المستمدة من أي من المعلومات الشخصية المجمعة المدرجة أعلاه لإنشاء
                ملف تعريف أو ملخص حول ، على سبيل المثال ، تفضيلات الفرد وخصائصه.
                لا
              </p>
              <p>م. المعلومات الشخصية الحساسة. لا</p>
              <h6>
                سنستخدم المعلومات الشخصية التي تم جمعها ونحتفظ بها حسب الحاجة
                لتوفير الخدمات أو من أجل:
              </h6>
              <ul>
                <li>الفئة أ - طالما أن المستخدم لديه حساب معنا</li>
                <li>الفئة ب - طالما أن المستخدم لديه حساب معنا</li>
                <li>الفئة F - سنة واحدة</li>
                <li>
                  الفئة G - طالما أن المستخدم لديه حساب معنا يجوز لنا أيضًا جمع
                  معلومات شخصية أخرى خارج هذه الفئات من خلال الحالات التي تتفاعل
                  فيها معنا شخصيًا أو عبر الإنترنت أو عبر الهاتف أو البريد في
                  سياق:
                </li>
                <li>تلقي المساعدة من خلال قنوات دعم العملاء لدينا.</li>
                <li>المشاركة في استبيانات العملاء أو المسابقات. و</li>
                <li>تسهيل تقديم خدماتنا والرد على استفساراتك.</li>
              </ul>
              <p>كيف نستخدم معلوماتك الشخصية ونشاركها؟</p>
              <p>
                تقوم شركة Systech Digital Co.Ltd بجمع معلوماتك الشخصية ومشاركتها
                من خلال:
              </p>
              <ul>
                <li>
                  استهداف ملفات تعريف الارتباط / ملفات تعريف الارتباط التسويقية
                </li>
                <li>
                  ملفات تعريف الارتباط الخاصة بوسائل التواصل الاجتماعي يمكن
                  العثور على مزيد من المعلومات حول ممارسات جمع البيانات
                  ومشاركتها في إشعار الخصوصية هذا.
                </li>
              </ul>
              <p>
                يمكنك الاتصال بنا عبر البريد الإلكتروني على info@systechsd.net ،
                أو بالرجوع إلى تفاصيل الاتصال في أسفل هذه الوثيقة.
              </p>
              <p>
                إذا كنت تستخدم وكيلًا معتمدًا لممارسة حقك في إلغاء الاشتراك ،
                فقد نرفض طلبًا إذا لم يقدم الوكيل المعتمد دليلًا على أنه قد تم
                تفويضه بشكل صحيح للتصرف نيابة عنك.
              </p>
              <p>هل سيتم مشاركة معلوماتك مع أي شخص آخر؟</p>
              <p>
                يجوز لنا الكشف عن معلوماتك الشخصية مع مزودي الخدمة لدينا بموجب
                عقد مكتوب بيننا وبين كل مقدم خدمة. كل مقدم خدمة هو كيان ربحي
                يعالج المعلومات نيابة عنا ، باتباع نفس التزامات حماية الخصوصية
                الصارمة التي تفرضها CCPA.
              </p>
              <p>
                قد نستخدم معلوماتك الشخصية لأغراض تجارية خاصة بنا ، مثل إجراء
                بحث داخلي للتطوير التكنولوجي والعرض. لا يعتبر هذا بمثابة "بيع"
                لمعلوماتك الشخصية.
              </p>
              <p>
                لم تقم شركة Systech Digital Co.ltd ببيع أو مشاركة أي معلومات
                شخصية لأطراف ثالثة لأغراض تجارية أو تجارية في الاثني عشر (12)
                شهرًا السابقة. كشفت شركة Systech Digital Co.ltd عن الفئات
                التالية من المعلومات الشخصية لأطراف ثالثة لأغراض تجارية أو
                تجارية في الاثني عشر (12) شهرًا السابقة: يمكن العثور على فئات
                الأطراف الثالثة التي كشفنا لها عن معلومات شخصية لأغراض تجارية أو
                تجارية ضمن "متى ومع من نشارك معلوماتك الشخصية؟".
              </p>
              <p>حقوقك فيما يتعلق ببياناتك الشخصية</p>
              <p>الحق في طلب حذف البيانات - طلب الحذف</p>
              <p>
                يمكنك طلب حذف معلوماتك الشخصية. إذا طلبت منا حذف معلوماتك
                الشخصية ، فسنحترم طلبك ونحذف معلوماتك الشخصية ، مع مراعاة بعض
                الاستثناءات التي ينص عليها القانون ، مثل (على سبيل المثال لا
                الحصر) ممارسة مستهلك آخر لحقه في حرية التعبير. ، أو متطلبات
                الامتثال الخاصة بنا الناتجة عن التزام قانوني ، أو أي معالجة قد
                تكون مطلوبة للحماية من الأنشطة غير القانونية.
              </p>
              <p>الحق في الحصول على المعلومات - طلب المعرفة</p>
              <p>حسب الظروف ، لديك الحق في معرفة:</p>
              <ul>
                <li>ما إذا كنا نجمع معلوماتك الشخصية ونستخدمها ؛</li>
                <li>فئات المعلومات الشخصية التي نجمعها.</li>
                <li>
                  الأغراض التي من أجلها يتم استخدام المعلومات الشخصية التي تم
                  جمعها ؛
                </li>
                <li>
                  ما إذا كنا نبيع أو نشارك المعلومات الشخصية لأطراف ثالثة ؛
                </li>
                <li>
                  فئات المعلومات الشخصية التي قمنا ببيعها أو مشاركتها أو الكشف
                  عنها لغرض تجاري ؛
                </li>
                <li>
                  فئات الأطراف الثالثة التي تم بيع المعلومات الشخصية لها أو
                  مشاركتها أو الكشف عنها لغرض تجاري ؛
                </li>
                <li>
                  العمل أو الغرض التجاري لجمع المعلومات الشخصية أو بيعها أو
                  مشاركتها ؛ و
                </li>
                <li>الأجزاء المحددة من المعلومات الشخصية التي جمعناها عنك.</li>
              </ul>
              <p>
                وفقًا للقانون المعمول به ، لسنا ملزمين بتقديم أو حذف معلومات
                المستهلك التي تم إلغاء تحديد هويتها استجابة لطلب المستهلك أو
                إعادة تحديد البيانات الفردية للتحقق من طلب المستهلك.
              </p>
              <p>الحق في عدم التمييز لممارسة حقوق الخصوصية للمستهلك</p>
              <p>لن نميز ضدك إذا مارست حقوق الخصوصية الخاصة بك.</p>
              <p>الحق في تقييد استخدام والكشف عن المعلومات الشخصية الحساسة</p>
              <p>نحن لا نعالج المعلومات الشخصية الحساسة للمستهلك.</p>
              <p>عملية التحقق</p>
              <p>
                عند تلقي طلبك ، سنحتاج إلى التحقق من هويتك لتحديد أنك نفس الشخص
                الذي لدينا معلومات عنه في نظامنا. تتطلب منا جهود التحقق هذه أن
                نطلب منك تقديم معلومات حتى نتمكن من مطابقتها مع المعلومات التي
                قدمتها لنا مسبقًا. على سبيل المثال ، بناءً على نوع الطلب الذي
                ترسله ، قد نطلب منك تقديم معلومات معينة حتى نتمكن من مطابقة
                المعلومات التي تقدمها مع المعلومات الموجودة لدينا بالفعل في
                الملف ، أو قد نتصل بك من خلال وسيلة اتصال (على سبيل المثال ،
                الهاتف أو البريد الإلكتروني) الذي قدمته إلينا مسبقًا. يجوز لنا
                أيضًا استخدام طرق تحقق أخرى حسب ما تمليه الظروف.
              </p>
              <p>
                سنستخدم فقط المعلومات الشخصية المقدمة في طلبك للتحقق من هويتك أو
                سلطتك لتقديم الطلب. إلى أقصى حد ممكن ، سوف نتجنب طلب معلومات
                إضافية منك لأغراض التحقق. ومع ذلك ، إذا لم نتمكن من التحقق من
                هويتك من المعلومات التي نحتفظ بها بالفعل ، فقد نطلب منك تقديم
                معلومات إضافية لأغراض التحقق من هويتك
              </p>
              <p>
                ولأغراض الأمان أو منع الاحتيال. سنحذف هذه المعلومات المقدمة
                بالإضافة إلى ذلك بمجرد أن ننتهي من التحقق منك.
              </p>
              <p>حقوق الخصوصية الأخرى</p>
              <ul>
                <li>يمكنك الاعتراض على معالجة معلوماتك الشخصية.</li>
                <li>
                  يمكنك طلب تصحيح بياناتك الشخصية إذا كانت غير صحيحة أو لم تعد
                  ذات صلة ، أو تطلب تقييد معالجة المعلومات.
                </li>
                <li>
                  يمكنك تعيين وكيل معتمد لتقديم طلب بموجب قانون كاليفورنيا
                  لحماية خصوصية المستهلك نيابة عنك. قد نرفض طلبًا من وكيل معتمد
                  لا يقدم دليلاً على أنه قد تم تفويضه بشكل صحيح للتصرف نيابةً
                  عنك وفقًا لقانون حماية خصوصية المستهلك (CCPA).
                </li>
                <li>
                  يمكنك طلب الانسحاب من البيع أو المشاركة في المستقبل لمعلوماتك
                  الشخصية لأطراف ثالثة. عند تلقي طلب إلغاء الاشتراك ، سنتصرف
                  بناءً على الطلب في أقرب وقت ممكن عمليًا ، ولكن في موعد لا
                  يتجاوز خمسة عشر (15) يومًا من تاريخ تقديم الطلب.
                </li>
              </ul>
              <p>
                لممارسة هذه الحقوق ، يمكنك الاتصال بنا عبر البريد الإلكتروني على
                info@systechsd.net ، أو بالرجوع إلى تفاصيل الاتصال في أسفل هذا
                المستند. إذا كانت لديك شكوى حول كيفية تعاملنا مع بياناتك ، فنحن
                نود أن نسمع منك.
              </p>
            </div>
            <!-- ten  -->
            <div>
              <p>10. هل نجري تحديثات على هذا الإشعار؟</p>
              <p>
                باختصار: نعم ، سنقوم بتحديث هذا الإشعار حسب الضرورة للبقاء
                ملتزمًا بالقوانين ذات الصلة.
              </p>
              <p>
                قد نقوم بتحديث إشعار الخصوصية هذا من وقت لآخر. ستتم الإشارة إلى
                الإصدار المحدّث من خلال تاريخ محدّث "منقّح" وستصبح النسخة
                المحدّثة سارية حالما يمكن الوصول إليها. إذا أجرينا تغييرات
                جوهرية على إشعار الخصوصية هذا ، فقد نخطرك إما عن طريق نشر إشعار
                واضح بهذه التغييرات أو بإرسال إشعار إليك مباشرةً. نحن نشجعك على
                مراجعة إشعار الخصوصية هذا بشكل متكرر لتكون على علم بكيفية حماية
                معلوماتك.
              </p>
            </div>
            <!-- eleven -->
            <div>
              <p>11. كيف يمكنك الاتصال بنا بخصوص هذا الإشعار؟</p>
              <p>
                إذا كانت لديك أسئلة أو تعليقات حول هذا الإشعار ، فيمكنك مراسلتنا
                عبر البريد الإلكتروني على info@systechsd.net
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>